import React from 'react';
import PDFViewer from '../../components/TimeTableViewer';

function StudentTimetable() {

  return (<div style={{ padding: "1rem" }}><PDFViewer /></div>);
}

export default StudentTimetable;
